import { creditCardDetailsEntryStyles as styles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";
import { css } from "styled-components";

styles.cardNumberGridItem = {
    ...styles.cardNumberGridItem,
    css: css`
        input {
            width: 99.9% !important;
            height: 40px;
        }
    `,
};

styles.securityCodeGridItem = {
    ...styles.securityCodeGridItem,
    css: css`
        input {
            width: 99.9% !important;
            height: 40px;
        }
    `,
};
styles.cardNumberText = {
    ...styles.cardNumberText,
    cssOverrides: {
        formField: css`
            width: 99.9%;
            height: 40px;
        `,
    },
};

styles.securityCodeText = {
    ...styles.securityCodeText,
    cssOverrides: {
        formField: css`
            width: 99.9%;
            height: 40px;
        `,
    },
};
